export default "/images/15687e71ca08512ca872de2de1023194.avif";